import { useContext } from 'react';
import ErrorModalContext from '../../context/ErrorModalContext';

function useErrorModal() {
  const { handleOpen } = useContext(ErrorModalContext);

  return { handleOpen };
}

export default useErrorModal;
